export default __webpack_public_path__ + "static/fur-hero-mobile-2e2a0d3f011fcc288c0c70b7b000cdc4.png";